import getClientInfo from '@btcdirect/api/client-info';
import { hasErrorCode } from '@btcdirect/shared/src/composables/api/exception/exception';
import { ApiErrorCodes } from '@btcdirect/shared/src/composables/api/types';
import { useLogger } from '@btcdirect/shared/src/composables/util/logger';
import { useAuthenticationStore } from '@btcdirect/stores';

const { debug, warn } = useLogger();

export const useClientAuthentication = () => {
    const authenticate = async (): Promise<void> => {
        const authenticationStore = useAuthenticationStore();

        if (!authenticationStore.client.token) {
            warn('No client authentication token has been provided');
            authenticationStore.setClientAuthentication(false);
            return;
        }

        if (authenticationStore.client.initialized) {
            debug('Client has already been authenticated');
            return;
        }

        try {
            await authenticateClient();
            authenticationStore.setClientAuthentication(true);

            debug('Authenticated the client successfully');
        } catch (exception) {
            authenticationStore.setClientAuthentication(false);
            warn('Could not authenticate the client. Did you use the correct key?');
        }
    };

    return {
        authenticate
    };
};

/**
 * Authenticate the client by getting the currency pairs from the API.
 * If it doesn't return errors ER805 or ER806, we at least know that the API key is valid.
 */
async function authenticateClient(): Promise<void> {
    try {
        await getClientInfo();
    } catch (exception) {
        // If the error is not an API key error, the client is authenticated correctly
        if (!hasErrorCode([ApiErrorCodes.ER999, ApiErrorCodes.ER805, ApiErrorCodes.ER806], exception)) {
            return Promise.resolve();
        }

        throw exception;
    }
}
